import {FC} from "react";
import {PageEnum, TransactionReportSearchParamsModel} from "../../../models";
import {ReportPage, ReportProfitOfSaleSearchPanel} from "../../../components";
import {searchReportProfitOfSales} from "../../../serviceBroker/transationReportApiServiceBroker";
import {getPageNameByPageId, getSystemLanguageId} from "../../../utils";

export const ReportProfitOfSalePage: FC = () => {
    const initialState: TransactionReportSearchParamsModel = {
        Lang: getSystemLanguageId(),
        lang: getSystemLanguageId(),
    };
    return (
        <ReportPage
            InitialState={initialState}
            SearchApi={searchReportProfitOfSales}
            searchHeader={getPageNameByPageId(PageEnum.ReportProfitOfSales)}
            SearchPanel={ReportProfitOfSaleSearchPanel}
            formId={PageEnum.ReportProfitOfSales}
        />
    );
};
